/**
 * サンプルクラス
 * @constructor
 */
class HeaderFooterInc {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    let url = location.href,
      ch = '/chinese/',
      th = '/thai/',
      vi = '/vietnamese/',
      urlAw = '/saran/global/asahiwrap/',
      urlCp = '/saran/global/cookper/',
      menuNameArrayCH = ['食品用PVDC保鲜膜', '平底锅用铝箔', '烘焙纸', '查询'],
      menuNameArrayTh = ['แผ่นฟิล์ม PVDC สำหรับห่ออาหาร', 'แผ่นอลูมิเนียมฟอยล์สำหรับใช้กับกระทะ', 'แผ่นรองสำหรับประกอบอาหาร', 'ติดต่อสอบถาม'],
      menuNameArrayVi = ['Màng bọc PVDC dùng cho thực phẩm', 'Màng nhôm không dầu dùng cho chảo', 'Giấy nến', 'Liên hệ'];
    
    $(function () {
      // ヘッダー読み込みとcallback処理
      if ($('#j-header')[0]) {
        $("#j-header").load("/saran/global/assets/include/header.html", function() {
          headerMenu();
          headerSearch();
          headerLink();
          iPadAct();
        });
      }

      // フッター読み込みとcallback処理
      if ($('#j-footer')[0]) {
        $("#j-footer").load("/saran/global/assets/include/footer.html", function() {
          footerAct();
        });
      }
    });

    function headerMenu() {
      $('.j-header-menu').unbind('click').on('click', function () {
        $(this).toggleClass("is-active");
        $('.j-header-navsp').slideToggle();
        $('body').toggleClass('overflow');
      });
      $('.header-navsp__item--03').unbind('click').on('click', function () {
        $('.j-header-menu').removeClass("is-active");
        $('.j-header-navsp').slideToggle();
      });
      $('.header-navsp__item--04').unbind('click').on('click', function () {
        $('.j-header-menu').removeClass("is-active");
        $('.j-header-navsp').slideToggle();
      });
      $(window).scroll(function(){
        if ($(window).width() > 768) {
          if ($(".j-menu").length == 0) {
            var nowScrollTop = $(this).scrollTop();
            var headerHeight = $('.j-header').height();
            if(nowScrollTop > headerHeight){
              $('.j-nav-link').addClass("no-arrow");
            }
            else {
              $('.j-nav-link').removeClass("no-arrow");
            }
          }
        }
      });
    }

    // ヘッダーの検索ボタン処理
    function headerSearch() {
      $('body').on("click", ".j-search", function (e) {
        $(this).toggleClass("is-active");
        $(this).next().toggleClass("is-active");
      });
    }

    // ヘッダーのリンク、検索の文言
    function headerLink () {
      let array,
        keywordSw; // 「キーワード」という単語の各国語

      if (url.match(ch)) {
        urlTransition('chinese');
        array = menuNameArrayCH;
        keywordSw = '关键字';
        headerLinkText(array, keywordSw);
      } else if (url.match(th)) {
        urlTransition('thai');
        array = menuNameArrayTh;
        keywordSw = 'คีย์เวิร์ด';
        headerLinkText(array, keywordSw);
      } else if (url.match(vi)) {
        urlTransition('vietnamese');
        array = menuNameArrayVi;
        keywordSw = 'từ khóa';
        headerLinkText(array, keywordSw);
      } else {
        urlTransition('english');
      }

      function headerLinkText(textArray,search) {
        for (var i=0; i<4; i++) {
          $('#j-nav-link0'+(i+1)).html(textArray[i]);
          $('.header-navsp__item--0'+(i+1)).find('.navsp-link').html(textArray[i]);
        }
        $('#search01').attr('placeholder', search);
      }
  
      // ヘッダーメニューのボタンを押下時の遷移先
      function urlTransition(countryVal) {
        $('#j-nav-link01,#j-nav-link01--sp').on('click', (e) => {
          window.location.href = urlAw + countryVal+ "/";
        });
        $('#j-nav-link02,#j-nav-link02--sp').on('click', (e) => {
          window.location.href = urlCp + countryVal+ "/";
        });
        $('#j-nav-link03,#j-nav-link03--sp').on('click', (e) => {
          if (url.match(vi)) {
            window.location.href = urlCp + countryVal+ "/";
          } else {
            window.location.href = urlCp + countryVal+ "#anc02";
          }
        });
      }
    }

    // ヘッダー周りのiPad時の変更
    function iPadAct() {
      var ua = navigator.userAgent,
        windowWidth;
        // alert(ua);
      var agent = window.navigator.userAgent.toLowerCase();
      var ipad = agent.indexOf('ipad') > -1 || agent.indexOf('macintosh') > -1 && 'ontouchend' in document;
      if (ipad == true) {
        $('.m-asahiwrapKv_text').addClass('ipad');
      }

    }


    // フッターの動作
    function footerAct() {

      let array, // フッターのリンク文言の各国版
        linkTextArray;

      if (url.match(ch)) {
        array = ['网站地图', '关于本网站', '隐私政策', '旭化成集团首页'];
        linkTextArray = menuNameArrayCH;
        footerTextEach('日语页面');
        urlTransition('chinese');
      } else if (url.match(th)) {
        array = ['ผังเว็บไซต์', 'เกี่ยวกับเว็บไซต์นี้', 'นโยบายความเป็นส่วนตัว', 'ASAHI KASEI GROUP หน้าบนสุด'];
        linkTextArray = menuNameArrayTh;
        urlTransition('thai');
        footerTextEach('หน้าภาษาญี่ปุ่น');
      } else if (url.match(vi)) {
        array = ['Sơ đồ website', 'Về website này', 'Chính sách bảo mật', 'Trang chủ ASAHI KASEI GROUP'];
        linkTextArray = menuNameArrayVi;
        footerTextEach('Trang tiếng Nhật');
        urlTransition('vietnamese');
      } else {
        urlTransition('english');
      }

      // フッターのリンクの文言入れ込み
      function footerTextEach(glText) {
        $('.l-footer__subnavItem').each((index, element) => {
          const $this = $(element);
          $this.find('a').text(array[index]);
        });
        for (var i=0; i<4; i++) {
          $('.footer-nav__title--0'+(i+1)).find('.footer-nav__titlink').html(linkTextArray[i]);
        }
        $('#j-globalLink').text(glText);
      }
  
      // ヘッダーメニューのボタンを押下時の遷移先
      function urlTransition(countryVal) {
        $('.footer-nav__title--01').on('click', (e) => {
          window.location.href = urlAw + countryVal+ "/";
        });
        $('.footer-nav__title--02').on('click', (e) => {
          window.location.href = urlCp + countryVal+ "/";
        });
        $('.footer-nav__title--03').on('click', (e) => {
          if (url.match(vi)) {
            window.location.href = urlCp + countryVal+ "/";
          } else {
            window.location.href = urlCp + countryVal+ "#anc02";
          }
        });
      }
    }

  }
};

export default HeaderFooterInc;
